export default __webpack_public_path__ + "static/suma-fbd4b53e5dbee64dd72b383b1e01970e.png";